import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useLanguage } from "../../providers/language_provider";
import { Button } from "../common/Button";
import { FaSpotify } from "react-icons/fa";
import { ButtonDefault } from "../Button";

const WorkCard = ({ name, artist, cover, to }) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
      transition={{ duration: 0.6 }}
      className="group relative overflow-hidden rounded-lg"
    >
      <div className="aspect-w-16 aspect-h-9">
        <img
          src={cover}
          alt={name}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
          <h3 className="text-lg font-semibold mb-1">{name}</h3>
          <p className="text-sm text-gray-300">{artist}</p>
          <a
            href={to}
            target="_blank"
            className="inline-block mt-2 text-xs font-medium bg-primary-500 px-2 py-1 rounded"
          >
            <FaSpotify />
          </a>
        </div>
      </div>
    </motion.div>
  );
};

export function Works({ works, isAll }) {
  const { content } = useLanguage();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section
      className={`py-24 ${
        isAll ? "bg-gradient-to-b from-black via-gray-900 to-black" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Proyectos
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {works.map((work) => {
            if (work.cover === "cta") return <Cta />;
            else return <WorkCard {...work} />;
          })}
        </div>

        {isAll && (
          <div className="text-center mt-12">
            <Button
              text={content.seeMore}
              to="/catalogue"
              variant="outline"
              size="lg"
            />
          </div>
        )}
      </div>
    </section>
  );
}

const Cta = () => {
  const { content } = useLanguage();
  return (
    <div className="aspect-w-16 aspect-h-9 border border-dashed rounded-md ">
      <div className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110 flex flex-col justify-center items-center gap-2">
        <h1 className="text-gray-400">{content.workCta}</h1>
        <Button variant="primary" to={"/contact"} text={content.toContact} />
      </div>
    </div>
  );
};
